import { View } from "components/view/view.component";
import { Text } from 'components/text/text.component'
import styles from './roomReservationCard.module.css'
import { Icon } from "components/icon/icon.component";
import { toHourMinuteString } from "utils/date.util";

type RoomReservationCardProps = {
    title?: string,
    reserved?: boolean,
    occupied?: boolean,
    color?: string,
    reservedBy?: string,
    reserveStartAt?: Date,
    reserveEndAt?: Date,
    id?: string,
    sn?: string,
    capacity?: number,
    hoverText?: string
}

// export function RoomReservationCard({title = 'Erro', reserved, occupied, color, reservedBy, reserveStartAt, reserveEndAt, id, sn, capacity}: RoomReservationCardProps){
//     const _color = color ?? 'blue'
//     return <View className={styles.Card} style={{backgroundColor: `var(--${_color}-primary-color`, color: `var(--${_color}-primary-color-contrast)`}} id={id} sn={sn}>
//         <View className={styles.Content}>
//             <View className={styles.Header}>
//                 <View className={styles.Title}>
//                     <Text type="h3" style={{color: `var(--${_color}-primary-color-contrast)`}}>{title}</Text>
//                 </View>
//                 <View className={styles.Icon} style={{backgroundColor: `var(--${_color}-primary-color-contrast)`}}>
//                     <Icon style={{color: `var(--${_color}-primary-color`}}>{occupied === undefined ? 'warning': occupied ? 'door_front' :'door_open'}</Icon>
//                 </View>
//             </View>
//             <View className={styles.Body} >
//                 {capacity && <View className={styles.Row} style={{marginBottom: '5px'}}>
//                     <Icon fontSize="small" style={{color: `var(--${_color}-primary-color-contrast)`}}>{'person'}</Icon>
//                     <Text type='md' style={{color: `var(--${_color}-primary-color-contrast)`}}>{`${capacity} lugares`}</Text>
//                 </View>}
//                 <Text type="h4" style={{color: `var(--${_color}-primary-color-contrast)`}}>Status:</Text>
//                 {reserved !== undefined && <View className={styles.Row}>
//                     <Icon fontSize="small" style={{color: `var(--${_color}-primary-color-contrast)`}}>{reserved ? 'lock': 'lock_open'}</Icon>
//                     <Text type="md" style={{color: `var(--${_color}-primary-color-contrast)`}}>{reserved === undefined ? 'Erro ao obter dados' : reserved ? `Reservada - ${toHourMinuteString(reserveStartAt)} a ${toHourMinuteString(reserveEndAt)}`: 'Não Reservada'}</Text>
//                 </View>}
//                 {(reserved && reservedBy) && <View className={styles.Row}>
//                 <Icon fontSize="small" style={{color: `var(--${_color}-primary-color-contrast)`}}>person</Icon>
//                     <Text type="sm" style={{color: `var(--${_color}-primary-color-contrast)`}}>{reserved ? `Por ${reservedBy}`: ''}</Text>
//                 </View>}
//                 <View className={styles.Row}>
//                     <Icon fontSize="small" style={{color: `var(--${_color}-primary-color-contrast)`}}>{occupied ? 'door_front': 'door_open'}</Icon>
//                     <Text type='md' style={{color: `var(--${_color}-primary-color-contrast)`}}>{occupied === undefined ? 'Erro ao obter dados' : occupied ? 'Ocupada': 'Não Ocupada'}</Text>
//                 </View>
//             </View>
//         </View>
//     </View>
// }

// export function RoomReservationCard2({title = 'Erro', reserved, occupied, color, reservedBy, reserveStartAt, reserveEndAt, id, sn, capacity}: RoomReservationCardProps){
//     const _color = color ?? 'blue'
//     return <View className={styles.Card} style={{backgroundColor: `var(--${_color}-primary-color`, color: `var(--${_color}-primary-color-contrast)`}} id={id} sn={sn}>
//         <View className={styles.Content}>
//             <View className={styles.Header}>
//                 <View className={styles.Title}>
//                     <Text type="h3" style={{color: `var(--${_color}-primary-color-contrast)`}}>{title}</Text>
//                 </View>
//                 <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'center', gap: '2px' }}>
//                     <View className={styles.Icon} style={{backgroundColor: `var(--${_color}-primary-color-contrast)`}}>
//                         <Icon style={{color: `var(--${_color}-primary-color`}}>{occupied === undefined ? 'warning': occupied ? 'door_front' :'door_open'}</Icon>
//                     </View>
//                     <Text type='h3' style={{color: `var(--${_color}-primary-color-contrast)`, width: '100%', height: 'var(--icon-size)', textAlign: 'center', display:'flex', alignItems: 'center', justifyContent: 'center'}}>{capacity}</Text>
//                 </View>
//             </View>
//             <View className={styles.Body} >
//                 <Text type="h4" style={{color: `var(--${_color}-primary-color-contrast)`}}>Status:</Text>
//                 {reserved !== undefined && <View className={styles.Row}>
//                     <Icon fontSize="small" style={{color: `var(--${_color}-primary-color-contrast)`}}>{reserved ? 'lock': 'lock_open'}</Icon>
//                     <Text type="md" style={{color: `var(--${_color}-primary-color-contrast)`}}>{reserved === undefined ? 'Erro ao obter dados' : reserved ? `Reservada - ${toHourMinuteString(reserveStartAt)} a ${toHourMinuteString(reserveEndAt)}`: 'Não Reservada'}</Text>
//                 </View>}
//                 {(reserved && reservedBy) && <View className={styles.Row}>
//                 <Icon fontSize="small" style={{color: `var(--${_color}-primary-color-contrast)`}}>person</Icon>
//                     <Text type="sm" style={{color: `var(--${_color}-primary-color-contrast)`}}>{reserved ? `Por ${reservedBy}`: ''}</Text>
//                 </View>}
//                 <View className={styles.Row}>
//                     <Icon fontSize="small" style={{color: `var(--${_color}-primary-color-contrast)`}}>{occupied ? 'door_front': 'door_open'}</Icon>
//                     <Text type='md' style={{color: `var(--${_color}-primary-color-contrast)`}}>{occupied === undefined ? 'Erro ao obter dados' : occupied ? 'Ocupada': 'Não Ocupada'}</Text>
//                 </View>
//             </View>
//         </View>
//     </View>
// }

// export function RoomReservationCard3({title = 'Erro', reserved, occupied, color, reservedBy, reserveStartAt, reserveEndAt, id, sn, capacity}: RoomReservationCardProps){
//     const _color = color ?? 'blue'
//     return <View className={styles.Card} style={{backgroundColor: `var(--${_color}-primary-color`, color: `var(--${_color}-primary-color-contrast)`}} id={id} sn={sn}>
//         <View className={styles.Content}>
//             <View className={styles.Header}>
//                 <View className={styles.Title}>
//                     <Text type="h3" style={{color: `var(--${_color}-primary-color-contrast)`}}>{title}</Text>
//                 </View>
//                 <View className={styles.Icon} style={{backgroundColor: `var(--${_color}-primary-color-contrast)`}}>
//                     <Icon style={{color: `var(--${_color}-primary-color`}}>{occupied === undefined ? 'warning': occupied ? 'door_front' :'door_open'}</Icon>
//                 </View>
//             </View>
//             <View style={{display: 'flex', flexDirection: 'row', gap: '4px', width: '100%', alignItems: 'flex-end'}}>
//                 <View className={styles.Body} >
//                     <Text type="h4" style={{color: `var(--${_color}-primary-color-contrast)`}}>Status:</Text>
//                     {reserved !== undefined && <View className={styles.Row}>
//                         <Icon fontSize="small" style={{color: `var(--${_color}-primary-color-contrast)`}}>{reserved ? 'lock': 'lock_open'}</Icon>
//                         <Text type="md" style={{color: `var(--${_color}-primary-color-contrast)`}}>{reserved === undefined ? 'Erro ao obter dados' : reserved ? `Reservada - ${toHourMinuteString(reserveStartAt)} a ${toHourMinuteString(reserveEndAt)}`: 'Não Reservada'}</Text>
//                     </View>}
//                     {(reserved && reservedBy) && <View className={styles.Row}>
//                     <Icon fontSize="small" style={{color: `var(--${_color}-primary-color-contrast)`}}>person</Icon>
//                         <Text type="sm" style={{color: `var(--${_color}-primary-color-contrast)`}}>{reserved ? `Por ${reservedBy}`: ''}</Text>
//                     </View>}
//                     <View className={styles.Row}>
//                         <Icon fontSize="small" style={{color: `var(--${_color}-primary-color-contrast)`}}>{occupied ? 'door_front': 'door_open'}</Icon>
//                         <Text type='md' style={{color: `var(--${_color}-primary-color-contrast)`}}>{occupied === undefined ? 'Erro ao obter dados' : occupied ? 'Ocupada': 'Não Ocupada'}</Text>
//                     </View>
//                 </View>
//                 <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
//                     <Text type='h3' style={{color: `var(--${_color}-primary-color-contrast)`, width: 'var(--icon-size)', height: 'var(--icon-size)', minWidth: 'var(--icon-size)', minHeight: 'var(--icon-size)', textAlign: 'center', display:'flex', alignItems: 'flex-end', justifyContent: 'center'}}>{capacity}</Text>
//                     <Text type='sm' style={{color: `var(--${_color}-primary-color-contrast)`, width: '100%', textAlign: 'center', display:'flex', alignItems: 'center', justifyContent: 'center'}}>lugares</Text>
//                 </View>
//             </View>
//         </View>
//     </View>
// }

// export function RoomReservationCard4({title = 'Erro', reserved, occupied, color, reservedBy, reserveStartAt, reserveEndAt, id, sn, capacity}: RoomReservationCardProps){
//     const _color = color ?? 'blue'
//     return <View className={styles.Card} style={{backgroundColor: `var(--${_color}-primary-color`, color: `var(--${_color}-primary-color-contrast)`}} id={id} sn={sn}>
//         <View className={styles.Content}>
//             <View className={styles.Header}>
//                 <View className={styles.Title}>
//                     <Text type="h3" style={{color: `var(--${_color}-primary-color-contrast)`}}>{title}</Text>
//                 </View>
//                 <View className={styles.Icon} style={{backgroundColor: `var(--${_color}-primary-color-contrast)`}}>
//                     <Icon style={{color: `var(--${_color}-primary-color`}}>{occupied === undefined ? 'warning': occupied ? 'door_front' :'door_open'}</Icon>
//                 </View>
//             </View>
//             <View className={styles.Body} >
//                 {capacity && <>
//                 <Text type="h4" style={{color: `var(--${_color}-primary-color-contrast)`}}>Capacidade:</Text>
//                 <View className={styles.Row}>
//                     <Icon fontSize="small" style={{color: `var(--${_color}-primary-color-contrast)`}}>{'person'}</Icon>
//                     <Text type='md' style={{color: `var(--${_color}-primary-color-contrast)`}}>{`${capacity} lugares`}</Text>
//                 </View></>}
//                 <Text type="h4" style={{color: `var(--${_color}-primary-color-contrast)`, marginTop: '.4rem'}}>Status:</Text>
//                 {reserved !== undefined && <View className={styles.Row}>
//                     <Icon fontSize="small" style={{color: `var(--${_color}-primary-color-contrast)`}}>{reserved ? 'lock': 'lock_open'}</Icon>
//                     <Text type="md" style={{color: `var(--${_color}-primary-color-contrast)`}}>{reserved === undefined ? 'Erro ao obter dados' : reserved ? `Reservada - ${toHourMinuteString(reserveStartAt)} a ${toHourMinuteString(reserveEndAt)}`: 'Não Reservada'}</Text>
//                 </View>}
//                 {(reserved && reservedBy) && <View className={styles.Row}>
//                 <Icon fontSize="small" style={{color: `var(--${_color}-primary-color-contrast)`}}>person</Icon>
//                     <Text type="sm" style={{color: `var(--${_color}-primary-color-contrast)`}}>{reserved ? `Por ${reservedBy}`: ''}</Text>
//                 </View>}
//                 <View className={styles.Row}>
//                     <Icon fontSize="small" style={{color: `var(--${_color}-primary-color-contrast)`}}>{occupied ? 'door_front': 'door_open'}</Icon>
//                     <Text type='md' style={{color: `var(--${_color}-primary-color-contrast)`}}>{occupied === undefined ? 'Erro ao obter dados' : occupied ? 'Ocupada': 'Não Ocupada'}</Text>
//                 </View>
//             </View>
//         </View>
//     </View>
// }

// export function RoomReservationCard5({title = 'Erro', reserved, occupied, color, reservedBy, reserveStartAt, reserveEndAt, id, sn, capacity}: RoomReservationCardProps){
//     const _color = color ?? 'blue'
//     return <View className={styles.Card} style={{backgroundColor: `var(--${_color}-primary-color`, color: `var(--${_color}-primary-color-contrast)`}} id={id} sn={sn}>
//         <View className={styles.Content}>
//             <View className={styles.Header}>
//                 <View className={styles.Title}>
//                     <Text type="h3" style={{color: `var(--${_color}-primary-color-contrast)`}}>{title}</Text>
//                 </View>
//                 <View className={styles.Icon} style={{backgroundColor: `var(--${_color}-primary-color-contrast)`}}>
//                     <Icon style={{color: `var(--${_color}-primary-color`}}>{occupied === undefined ? 'warning': occupied ? 'door_front' :'door_open'}</Icon>
//                 </View>
//             </View>
//             <View className={styles.Body} >
                
//                 <Text type="h4" style={{color: `var(--${_color}-primary-color-contrast)`}}>Status:</Text>
//                 {reserved !== undefined && <View className={styles.Row}>
//                     <Icon fontSize="small" style={{color: `var(--${_color}-primary-color-contrast)`}}>{reserved ? 'lock': 'lock_open'}</Icon>
//                     <Text type="md" style={{color: `var(--${_color}-primary-color-contrast)`}}>{reserved === undefined ? 'Erro ao obter dados' : reserved ? `Reservada - ${toHourMinuteString(reserveStartAt)} a ${toHourMinuteString(reserveEndAt)}`: 'Não Reservada'}</Text>
//                 </View>}
//                 {(reserved && reservedBy) && <View className={styles.Row}>
//                 <Icon fontSize="small" style={{color: `var(--${_color}-primary-color-contrast)`}}>person</Icon>
//                     <Text type="sm" style={{color: `var(--${_color}-primary-color-contrast)`}}>{reserved ? `Por ${reservedBy}`: ''}</Text>
//                 </View>}
//                 <View className={styles.Row}>
//                     <Icon fontSize="small" style={{color: `var(--${_color}-primary-color-contrast)`}}>{occupied ? 'door_front': 'door_open'}</Icon>
//                     <Text type='md' style={{color: `var(--${_color}-primary-color-contrast)`}}>{occupied === undefined ? 'Erro ao obter dados' : occupied ? 'Ocupada': 'Não Ocupada'}</Text>
//                 </View>
//                 {capacity && <View className={styles.Row} >
//                     <Icon fontSize="small" style={{color: `var(--${_color}-primary-color-contrast)`}}>{'person'}</Icon>
//                     <Text type='md' style={{color: `var(--${_color}-primary-color-contrast)`}}>{`${capacity} lugares`}</Text>
//                 </View>}
//             </View>
//         </View>
//     </View>
// }

export function RoomReservationCard({title = 'Erro', reserved, occupied, color, reservedBy, reserveStartAt, reserveEndAt, id, sn, capacity, hoverText}: RoomReservationCardProps){
    const _color = color ?? 'blue'
    return <View className={styles.Card} style={{backgroundColor: `var(--${_color}-primary-color`, color: `var(--${_color}-primary-color-contrast)`}} id={id} sn={sn} title={hoverText}>
        <View className={styles.Content}>
            <View className={styles.Header}>
                <View className={styles.Title}>
                    <Text type="h3" style={{color: `var(--${_color}-primary-color-contrast)`}}>{title}</Text>
                </View>
                <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <View className={styles.Icon} style={{backgroundColor: `var(--${_color}-primary-color-contrast)`}}>
                        <Icon style={{color: `var(--${_color}-primary-color`}}>{occupied === undefined ? 'warning': occupied ? 'door_front' :'door_open'}</Icon>
                    </View>
                    {capacity !== undefined &&
                        <>
                            <Text type='h3' style={{color: `var(--${_color}-primary-color-contrast)`, width: '100%', marginTop: '10px', textAlign: 'center', display:'flex', alignItems: 'center', justifyContent: 'center'}}>{capacity}</Text>
                            <Text type='sm' style={{color: `var(--${_color}-primary-color-contrast)`, width: '100%', textAlign: 'center', display:'flex', alignItems: 'center', justifyContent: 'center'}}>lugares</Text>
                        </>
                    }
                </View>
            </View>
            <View className={styles.Body} >
                <Text type="h4" style={{color: `var(--${_color}-primary-color-contrast)`}}>Status:</Text>
                {reserved !== undefined && <View className={styles.Row}>
                    <Icon fontSize="small" style={{color: `var(--${_color}-primary-color-contrast)`}}>{reserved ? 'lock': 'lock_open'}</Icon>
                    <Text type="md" style={{color: `var(--${_color}-primary-color-contrast)`}}>{reserved === undefined ? 'Erro ao obter dados' : reserved ? `Reservada - ${toHourMinuteString(reserveStartAt)} a ${toHourMinuteString(reserveEndAt)}`: 'Não Reservada'}</Text>
                </View>}
                {(reserved && reservedBy) && <View className={styles.Row}>
                <Icon fontSize="small" style={{color: `var(--${_color}-primary-color-contrast)`}}>person</Icon>
                    <Text type="sm" style={{color: `var(--${_color}-primary-color-contrast)`}}>{reserved ? `Por ${reservedBy}`: ''}</Text>
                </View>}
                <View className={styles.Row}>
                    <Icon fontSize="small" style={{color: `var(--${_color}-primary-color-contrast)`}}>{occupied ? 'door_front': 'door_open'}</Icon>
                    <Text type='md' style={{color: `var(--${_color}-primary-color-contrast)`}}>{occupied === undefined ? 'Erro ao obter dados' : occupied ? 'Ocupada': 'Não Ocupada'}</Text>
                </View>
            </View>
        </View>
    </View>
}